export default __webpack_public_path__ + "fonts/expect.803191389c71885badc880ecf0b3c793.png";